import { Action } from '@ngrx/store';
import { MetadataFilter } from 'search/models/search-card';

export const FILTER_REQUEST = '[Search Card Terms] Requesting for filtered asset';
export const FILTER_RESPONSE = '[Search Card Terms] Response for filtered asset';

export class FilterRequestAction implements Action {
  public readonly type = FILTER_REQUEST;

  constructor(public payload: MetadataFilter) {
  }
}

export class FilterResponseAction implements Action {
  public readonly type = FILTER_RESPONSE;

  constructor(public payload: any) {
  }
}

export type SearchFilterActions =
  | FilterRequestAction
  | FilterResponseAction;
